import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tile_selectable = _resolveComponent("tile-selectable")!
  const _component_tile_button = _resolveComponent("tile-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ tile: _ctx.model.tileVariant !== _ctx.TileVariantEnum.Button }])
  }, [
    (_ctx.model.tileVariant == _ctx.TileVariantEnum.Select)
      ? (_openBlock(), _createBlock(_component_tile_selectable, {
          key: 0,
          model: _ctx.model
        }, null, 8, ["model"]))
      : _createCommentVNode("", true),
    (_ctx.model.tileVariant == _ctx.TileVariantEnum.Button)
      ? (_openBlock(), _createBlock(_component_tile_button, {
          key: 1,
          model: _ctx.model
        }, null, 8, ["model"]))
      : _createCommentVNode("", true)
  ], 2))
}